angular.module("vgresiduos").controller("ProcessEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `unidades/processo/${$stateParams.id}`);
		};
	}
]);
